export default __webpack_public_path__ + "static/media/Digital Delay.f9dd1fe2.png";